<template>
  <div class="billing-payment-form">
    <zm-alert
      v-if="warningMsg"
      :title="warningMsg"
      :closable="false"
      class="billing-payment-form__warning-msg"
      type="warning"
      show-icon
    />
    <payment-cards
      v-if="action !== PAYMENT_ACTION_TYPE.UPDATE_EXPIRATION"
      v-model="paymentMethod"
      @change="changePaymentMethod"
    />
    <payment-method-form
      ref="paymentMethodForm"
      :payment-method="paymentMethod"
      :alert-visible="isNeedVerified"
      :indiaMandateAmount="indiaMandateAmount"
      :indiaMandateAmountFormatted="indiaMandateAmountFormatted"
      :enable-inr-recurring-charges-table="enableInrRecurringChargesTable"
      :save-disabled="saveDisabled"
      @authorize="(e) => $emit('authorize', e)"
      @loading-start="onLoadingStart"
      @loading-close="onLoadingClose"
      @submit-success="onSubmitSuccess"
      @submit-error="onSubmitError"
      @submit-start="onSubmitStart"
    ></payment-method-form>
  </div>
</template>

<script type="text/jsx">
import PaymentCards from "./PaymentCards";
import PaymentMethodForm from "./PaymentMethodForm";
import { PaymentComponentName, PAYMENT_ACTION_TYPE } from '../../common/constant';
import { getCurrency } from '../../utils/currency';
import { mapGetters, mapMutations } from 'vuex';
import { APP_NAMESPACE } from "../../store";
import { translateMixins } from "../../plugins/i18n";

export default {
  name: 'payment',
  componentName: PaymentComponentName,
  components: { PaymentCards, PaymentMethodForm },
  mixins: [translateMixins],
  props: {
    action: String,
    isPrimary: Boolean,
    isFreeAccount: Boolean,
    defaultPayMethod: String,
    payment: Object,
    saveDisabled: Boolean,
    account: {
      type: Object,
      default: () => ({
        firstName: '',
        lastName: '',
        email: ''
      })
    },
    indiaMandateAmount: String,
    indiaMandateAmountFormatted: String,
    enableInrRecurringChargesTable: Boolean,
    isCheckout: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      action: this.action,
      isPrimary: this.isPrimary,
      isFreeAccount: this.isFreeAccount,
      account: this.account,
      payment: this.payment,
      isCheckout: this.isCheckout
    }
  },
  data() {
    return {
      PAYMENT_ACTION_TYPE,
      paymentMethod: "",
      isNeedVerified: false
    }
  },
  created() {
    this.defaultPayMethod && this.changePaymentMethod(this.defaultPayMethod)
    if (this.action === PAYMENT_ACTION_TYPE.UPDATE_EXPIRATION) {
      this.setCvvReAuthInfo({
        accountId: this.billingInfo?.zAccountId,
        pmId: this.payment.id,
        isCreditCardReAuthRequired: true,
      })
    }
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['withCcAccount', 'billingInfo']),
    warningMsg() {
      if (getCurrency() === 'BRL') {
        return this.__$t('billing.payment.pay_with_international_card');
      }
      return null;
    }
  },
  methods: {
    ...mapMutations(APP_NAMESPACE, ['setSelectedPaymentMethod', 'setCvvReAuthInfo']),
    changePaymentMethod(paymentMethod = "") {
      this.paymentMethod = paymentMethod;
      this.setSelectedPaymentMethod(paymentMethod);
      this.$emit('pay-method-change', paymentMethod);
    },
    changePaymentVerifyStatus(isNeedVerified) {
      this.isNeedVerified = isNeedVerified;
    },
    onLoadingClose(msg) {
      this.$emit('loading-close', msg)
    },
    onLoadingStart(msg) {
      this.$emit('loading-start', msg)
    },
    onSubmitStart(msg) {
      this.$emit('submit-start', msg)
    },
    onSubmitError(err) {
      this.$emit('submit-error', err)
    },
    onSubmitSuccess(res) {
      this.$emit('submit-success', res)
    },
    $submit(data) {
      return this.$refs.paymentMethodForm.$submit(data)
    }
  },
  watch: {
    globalLoading: {
      immediate: true,
      handler(globalLoading) {
        if (!globalLoading && this.currentPayMethod) {
          this.paymentMethod = this.currentPayMethod;
        }
      },
    }
  },
  mounted() {
    this.$on('clear-update-status', () => {
      this.changePaymentVerifyStatus(false);
    });
  }
};
</script>

<style lang="scss">
.billing-payment-form {
  &__warning-msg {
    margin-bottom: 24px;
  }
}
</style>
